import { gql } from "graphql-request";

/**
 * The `linkpreview` entity is the shared cache for extracted metadata: one row
 * per normalised URL, reused by every post that mentions it, so a link shared
 * fifty times is scraped once. See `docs/blocks-schema-link-preview.txt` for
 * the portal schema these operations expect.
 */

export const GET_LINK_PREVIEWS = gql`
  query GetLinkPreviews(
    $where: linkpreviewFilterInput
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getlinkpreviews(
      where: $where
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      items {
        ItemId
        url
        type
        title
        description
        imageUrl
        siteName
        domain
        videoId
        CreatedDate
        LastUpdatedDate
      }
    }
  }
`;

export const INSERT_LINK_PREVIEW = gql`
  mutation InsertLinkPreview(
    $url: String!
    $type: String!
    $title: String
    $description: String
    $imageUrl: String
    $siteName: String
    $domain: String
    $videoId: String
  ) {
    insertlinkpreview(
      input: {
        url: $url
        type: $type
        title: $title
        description: $description
        imageUrl: $imageUrl
        siteName: $siteName
        domain: $domain
        videoId: $videoId
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

/** Refresh an existing row in place, so the URL keeps its single cache entry. */
export const UPDATE_LINK_PREVIEW = gql`
  mutation UpdateLinkPreview(
    $itemId: String!
    $type: String!
    $title: String
    $description: String
    $imageUrl: String
    $siteName: String
    $domain: String
    $videoId: String
  ) {
    updatelinkpreview(
      where: { ItemId: { eq: $itemId } }
      input: {
        type: $type
        title: $title
        description: $description
        imageUrl: $imageUrl
        siteName: $siteName
        domain: $domain
        videoId: $videoId
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
